import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import EditStatus from '../../common/EditStatus';
import NamedLocationsEditManagerList from './NamedLocationsEditManagerList';
import NamedLocationsMap from "./NamedLocationsMap";
import NamedLocationsEditLookup from "./NamedLocationsEditLookup";


import { useSessionContext } from '../../../contexts/SessionContext';


export default function NamedLocationsEdit(props) {
    //console.debug("RTS Break NamedLocationsEdit");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const history = useNavigate();
    //const display = props.display;
    const mode = props.mode;

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");

    const [showLookupModal, setShowLookupModal] = useState(false);

    const [idGuid, setIdGuid] = useState("00000000-0000-0000-0000-000000000000");
    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [region, setRegion] = useState('');
    const [zip, setZip] = useState('');
    const [geoLat, setGeoLat] = useState('-85.0716746');
    const [geoLng, setGeoLng] = useState('33.5666694');
    const [manager, setManager] = useState(null);
    const [status, setStatus] = useState(1);
    const [points, setPoints] = useState([]);
    const [search, setSearch] = useState(false);


    const fetchData = useCallback((idGuid) => {
        let apiURL = apiRoot + "/NamedLocations/GetLocationById/" + idGuid;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIdGuid(response.data.idGuid);
                setName(response.data.name!==null?response.data.name:'');
                setShortName(response.data.shortName!==null?response.data.shortName:'');
                setAddress1(response.data.address1!==null?response.data.address1:'');
                setAddress2(response.data.address2!==null?response.data.address2:'');
                setCity(response.data.city!==null?response.data.city:'');
                setRegion(response.data.region!==null?response.data.region:'');
                setZip(response.data.zip!==null?response.data.zip:'');
                setGeoLat(response.data.geoLat!==null?response.data.geoLat:'-85.0716746');
                setGeoLng(response.data.geoLng!==null?response.data.geoLng:'-33.5666694');
                setManager(response.data.manager);
                setStatus(response.data.status);
                setPoints(response.data.points);

                setIsLoading(false);
            }
        })
        .catch(error => {
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]); 
    
    
    useEffect(() => {
        if(mode === 1){
            fetchData(props.idGuid);
        }
        else{
            setIsLoading(false);
        }
    }, [mode, fetchData, props.idGuid]);  


    async function handleSubmit(e) {
        e.preventDefault();

        props.updateCurDataFx(0);

        let tmpPoints = [];
        let sumLat = 0;
        let sumLng = 0;
        for (var c = 0; c < points.length; c++) {
            tmpPoints.push( { lat: points[c][1], lng: points[c][0], pointSequence: c} );
            sumLat = sumLat + points[c][1];
            sumLng = sumLng + points[c][0];
        }

        let centerLat = sumLat/points.length;
        let centerLng = sumLng/points.length;

        let retAddress = await geocodeCenterPoint(centerLng, centerLat);

        let apiObj = {
            IdGuid: idGuid,
            Name: name===''?null:name,
            ShortName: shortName===''?null:shortName,
            Customer: sessionCustomer.customer,
            Address1: retAddress.address,
            Address2: null,
            City: retAddress.city,
            Region: retAddress.region,
            Zip: retAddress.zip,
            GeoLat: centerLat,
            GeoLng: centerLng,
            Manager: manager,
            Status:status,
            Points: tmpPoints,
            modifyUser: user.userName,
            createUser: user.userName
        };

        if (apiObj.Name === null || apiObj.Name.trim() === "") {
            props.setIsUpdatingFx(false);
            setErrorBody("Location name is required");
            setShowErrorModal(true);
            return;
        }

        if (apiObj.ShortName === null || apiObj.ShortName.trim() === "") {
            props.setIsUpdatingFx(false);
            setErrorBody("Location short name is required");
            setShowErrorModal(true);
            return;
        }

        if (apiObj.Points.length <= 3) {
            props.setIsUpdatingFx(false);
            setErrorBody("Location must have at least 4 points");
            setShowErrorModal(true);
            return;
        }

        if (mode === 1) {
            let apiURL = apiRoot + "/NamedLocations/UpdateLocation";

            axios
            .put(
                apiURL,
                apiObj,
                {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
                )
            .then(response => {
                history(-1);
            })
            .catch(error => {
                props.updateCurDataFx(1);
                setErrorBody("An error has occured.  Please review the console log for details.");
                console.log("RTS UpdateCustomerReel Error", error);
                setShowErrorModal(true);
            });
        }
        else {
            let apiURL = apiRoot + "/NamedLocations/CreateLocation";

            axios
            .post(
                apiURL,
                apiObj,
                {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
                )
            .then(response => {
                history(-1);
            })
            .catch(error => {
                props.updateCurDataFx(1);
                setErrorTitle("Create Error");
                setErrorBody("An error has occured.  Please review the console log for details.");
                console.log("RTS CreateLocation Error", error);
                setShowErrorModal(true);
            });
        }
    }


    function geocodeCenterPoint(lng, lat){
        return new Promise(function(resolve, reject){
            let retAddress = {
                    address:null,
                    city:null,
                    region:null,
                    zip:null
                }

            let query = lng + ',' + lat;
            let accessToken = 'pk.eyJ1IjoiamltcHRhayIsImEiOiJja3kzMXZyOHIwNnRvMnBwOGxrbWJ4ZDhiIn0.bWHzm3g7ZOvo1wcWf2w8fg';
            let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${accessToken}`;

            axios
            .get(
                apiURL,
                {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
                )
            .then(response => {

                if(response.data){
                    if(response.data.features && response.data.features.length > 0){
                        let features = response.data.features[0];


                        if(features.place_type){
                            let placeType = features.place_type[0];

                            if(placeType === 'address'){
                                if(features.place_name){
                                    let parts = features.place_name.split(',');

                                    retAddress.address = parts[0];
                                    retAddress.city = parts[1];

                                    let numIdx = parts[2].search(/\d/);
                                    retAddress.region = parts[2].substring(1, numIdx).trim();
                                    retAddress.zip = parts[2].substring(numIdx);
                                }
                            }
                        }
                    }
                }
                resolve(retAddress);
            })
            .catch(error => {
                console.log("RTS GeoCode Named Location Polygon Error", error);
                reject(retAddress);
            });
        });
    };



    function setSearchData(geoData){
        if(geoData){
            setAddress1(geoData.address1);
            setAddress2(geoData.address2);
            setCity(geoData.city);
            setRegion(geoData.region);
            setZip(geoData.zip);
            setGeoLat(geoData.lat);
            setGeoLng(geoData.lng);
            setShowLookupModal(false);
            setSearch(true);
        }
    }


    if(hasError){
        return(
            <Error />
        );
    };
    
    
    if(isLoading){
        return(
            <Loading />
        );
    };   


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="sm" open={showLookupModal}>
            <DialogTitle>Search For Location</DialogTitle>
            <DialogContent>
                <Box>
                    <NamedLocationsEditLookup setSearchDataFx={setSearchData} setShowLookupModalFx={setShowLookupModal} />
                </Box>            
            </DialogContent>
        </Dialog>          
        <Box>
            <form id="locationForm" onSubmit={handleSubmit}>
                <Box maxWidth="md" sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Box id="smBox" maxWidth="sm" sx={{width:smallForm?'auto':'600px'}}>
                <TextField
                    id="tbName"
                    margin="dense"
                    fullWidth
                    label="Name"
                    size="small"
                    required
                    value={name}
                    onChange={(e) => {props.setFormDirtyFx(1); setName(e.target.value);}}
                />
                <TextField
                    id="tbShortName"
                    margin="dense"
                    fullWidth
                    label="Short Name"
                    size="small"
                    required
                    value={shortName}
                    onChange={(e) => {props.setFormDirtyFx(1); setShortName(e.target.value);}}
                />
                <Box sx={{mt:1}}>
                    <NamedLocationsEditManagerList manager={manager} setManagerFx={setManager} setFormDirtyFx={props.setFormDirtyFx} />
                </Box>
                <Box>
                    <EditStatus status={status} setStatusFx={setStatus} setFormDirtyFx={props.setFormDirtyFx} /> 
                </Box>
                </Box>
                </Box>
                <Box sx={{ display:'flex', justifyContent:'center', mt:2, mb:.5 }}>
                    <Box sx={{display:'flex', justifyContent:'right', width:{xs:"350px", sm:"450px", md:"550px", lg:"700px"} }}>
                        <Button variant="contained" onClick={() => {setShowLookupModal(true);}}>Search</Button>
                    </Box>
                </Box>
                <Box sx={{display:"flex", alignItems:'center', justifyContent:'center', justifyItems:'center'}}>
                    <NamedLocationsMap search={search} setSearchFx={setSearch} centerLat={geoLat} centerLng={geoLng} data={points} setPointsFx={setPoints} mode={mode} formDirty={props.formDirty} setFormDirtyFx={props.setFormDirtyFx} />
                </Box>
                <Box sx={{textAlign:'center', mt:2}}>
                    <Button variant="contained" disabled={props.formDirty===1?false:true} type="submit" sx={{mr:2}}>Save</Button>
                </Box>
            </form>
        </Box>
        </>
    );
}